import React from 'react';
import Headerr from '../components/layout/header';
import Navbar from '../components/layout/navbar';
import { useState } from 'react';
import { useEffect } from 'react';
import Preloader from '../components/common/preloader';



import Sec1booking from '../sections/sec1-booking';
const Booking = () => {
          const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 2000);
    return () => clearTimeout(timer);
  }, []);

  if (loading) return <Preloader />
    return ( 
        <>
                    <main className='home-background'>
                        <Headerr />
                        <Sec1booking />
                        <Navbar />
                    </main>
        </>
     );
}
 
export default Booking;